import { hashHistory } from 'react-router';

import { toast } from '@finn-no/common-browserbundle';
import { trackEvent } from '../../../services/trackingService.js';

import { NEW_AGREEMENT_DATA_RECEIVED } from '../agreement/agreementActionTypes.js';
import { UPDATED_SAFE_TRADE_STATUS } from '../safeTradeActionTypes.js';
import {
    NEW_PAYMENT_DATA_RECEIVED,
    APPROVE_DISCOUNT_START,
    APPROVE_DISCOUNT_SUCCESS,
    APPROVE_DISCOUNT_ERROR,
    SUGGEST_DISCOUNT_START,
    SUGGEST_DISCOUNT_SUCCESS,
    SUGGEST_DISCOUNT_ERROR,
    CANCEL_TRADE_START,
    CANCEL_TRADE_SUCCESS,
    CANCEL_TRADE_ERROR,
} from './paymentActionTypes.js';
import viewActions from '../../viewActions.js';
import mapResponse from '../../responseMapper.js';
import { put } from '../../../services/jsonfetchservice.js';

function updateStatus({
    actionType,
    body = {},
    dispatch,
    errorType,
    itemType,
    itemId,
    partnerId,
    redirectOnError,
    startType,
    successType,
    toastMessage,
}) {
    dispatch({
        type: startType,
    });

    const payload = Object.assign(
        {},
        {
            actionType,
        },
        body
    );

    return put(`/safe-trade/${itemType}/${itemId}/${partnerId}.json`, payload)
        .then(response => response.json())
        .then(data => mapResponse(data, partnerId, itemType, itemId))
        .then(mappedResponse => {
            dispatch({
                type: NEW_AGREEMENT_DATA_RECEIVED,
                payload: mappedResponse.agreement,
            });
            dispatch({
                type: NEW_PAYMENT_DATA_RECEIVED,
                payload: mappedResponse.payment,
            });
            dispatch({
                type: UPDATED_SAFE_TRADE_STATUS,
                payload: mappedResponse.safeTrade.viewStatus,
            });

            dispatch({
                type: successType,
            });
            hashHistory.replace('/samtale');

            if (toastMessage) {
                toast({ message: toastMessage });
            }
        })
        .catch(() => {
            dispatch({
                type: errorType,
            });
            hashHistory.replace(redirectOnError);
        });
}

export function approveDiscount({ itemType, itemId, discount, partnerId }) {
    trackEvent(
        'trade.buyer-does-not-approve-item.seller-approves-discount',
        'success'
    );

    return dispatch =>
        updateStatus({
            dispatch,
            itemType,
            itemId,
            partnerId,
            body: { discount },
            actionType: viewActions.APPROVE_DISCOUNT,
            startType: APPROVE_DISCOUNT_START,
            successType: APPROVE_DISCOUNT_SUCCESS,
            errorType: APPROVE_DISCOUNT_ERROR,
            redirectOnError: '/losning/godta-avslag-feilet',
        });
}

export function suggestDiscount({ itemType, itemId, discount, partnerId }) {
    trackEvent(
        'trade.buyer-does-not-approve-item.seller-suggests-other-discount'
    );

    return dispatch =>
        updateStatus({
            dispatch,
            itemType,
            itemId,
            partnerId,
            body: { discount },
            actionType: viewActions.SUGGEST_DISCOUNT,
            startType: SUGGEST_DISCOUNT_START,
            successType: SUGGEST_DISCOUNT_SUCCESS,
            errorType: SUGGEST_DISCOUNT_ERROR,
            redirectOnError: '/losning/foresla-avslag-feilet',
            toastMessage: 'Forslaget er sendt',
        });
}

export function cancelTrade({ itemType, itemId, partnerId }) {
    return dispatch =>
        updateStatus({
            dispatch,
            itemType,
            itemId,
            partnerId,
            actionType: viewActions.REVERT_PAYMENT,
            startType: CANCEL_TRADE_START,
            successType: CANCEL_TRADE_SUCCESS,
            errorType: CANCEL_TRADE_ERROR,
            redirectOnError: '/hev-avtale-feilet',
            toastMessage: 'Kjøpet er hevet',
        });
}



// WEBPACK FOOTER //
// ./safeTrade/seller/payment/paymentActions.js